/**
 *
 */
import * as React from 'react';
import {observer} from "mobx-react";
import {IReservation} from "shared/IReservation";

import './ScheduledSlot.pcss';
import {DateTimeHelpers} from "shared/DateTimeHelpers";
import {DateTime, Duration} from "luxon";

interface Props {
  bundleName:string;
  onCancelReservation:(reservation:IReservation)=>void;
  onReschedule?:(reservation:IReservation)=>void;
  reservation:IReservation;
  uiWordSlot:string;
  uiWordReservation:string;
  timezone:string;
}

@observer
export class ScheduledSlot extends React.Component<Props> {
  render() {
    const {reservation, bundleName, onReschedule} = this.props;
    const startTime = DateTimeHelpers.parseDateTime(reservation.time);
    if(null===startTime) {
      return null;
    }
    const endTime = startTime.plus(Duration.fromObject({ minute: reservation.length }));
    return (
      <div className={"scheduled-slot"}>
        <div><p>{this.props.uiWordReservation} for:</p></div>
        <div><p><strong>{DateTimeHelpers.toLocaleString(startTime,DateTime.DATETIME_SHORT, this.props.timezone)}-{DateTimeHelpers.toLocaleString(endTime,DateTime.TIME_WITH_SHORT_OFFSET, this.props.timezone)}</strong></p></div>
        <div className={"white-button-stack"}>
          {onReschedule && <button className="white" onClick={()=>{ onReschedule(reservation) }}><span>Reschedule</span><span className={"material-icons"} aria-hidden={true}>east</span></button>}
          <button className="white" onClick={() => {
            this.props.onCancelReservation(this.props.reservation);
          }}>Cancel {this.props.uiWordReservation}</button>
        </div>
      </div>
    );
  }

}

